(function(){
  function init(){
    var wraps=document.querySelectorAll('.product__selectors .selector-wrapper');
    Array.prototype.forEach.call(wraps,function(w){
      if(w.dataset.bfSizeDone)return;
      var legend=w.querySelector('.radio__legend__option-name');
      if(!legend)return;
      var name=(legend.textContent||'').trim().toLowerCase();
      if(name.indexOf('izm')<0 && name.indexOf('size')<0)return;
      var btns=w.querySelector('.radio__buttons');
      if(!btns)return;
      var radios=btns.querySelectorAll('input[type=radio]');
      if(!radios.length)return;
      w.dataset.bfSizeDone='1';
      w.classList.add('bf-size-hidden');
      var sw=document.createElement('div');sw.className='bf-size-select-wrap';
      var sel=document.createElement('select');sel.className='bf-size-select';
      Array.prototype.forEach.call(radios,function(r){
        var o=document.createElement('option');
        o.value=r.value;
        var lbl=w.querySelector('label[for="'+r.id+'"]');
        o.textContent=(lbl?lbl.textContent:r.value).trim();
        if(r.checked)o.selected=true;
        if(r.disabled)o.disabled=true;
        sel.appendChild(o);
      });
      sel.addEventListener('change',function(){
        var t=null;Array.prototype.forEach.call(radios,function(r){if(r.value===sel.value)t=r;});
        if(t){t.checked=true;t.dispatchEvent(new Event('change',{bubbles:true}));t.dispatchEvent(new Event('input',{bubbles:true}));}
      });
      Array.prototype.forEach.call(radios,function(r){r.addEventListener('change',function(){if(r.checked)sel.value=r.value;});});
      sw.appendChild(sel);
      btns.parentNode.insertBefore(sw,btns.nextSibling);
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  setTimeout(init,800);setTimeout(init,2000);
})();

(function(){
  var MSGS=['BEZMAKSAS PIEGĀDE VISIEM PASŪTĪJUMIEM','30 DIENU NAUDA ATPAKAĻ GARANTIJA'];
  function initAnn(){
    var wrap=document.querySelector('.announcement__wrapper--top')||document.querySelector('[data-announcement-wrapper]');
    if(!wrap||wrap.dataset.bfAnnDone)return;
    var holder=wrap.querySelector('.announcement__bar-holder');
    if(!holder)return;
    wrap.dataset.bfAnnDone='1';
    holder.innerHTML='<div class="bf-ann"><span class="bf-ann__msg">'+MSGS[0]+'</span></div>';
    var el=holder.querySelector('.bf-ann__msg');var idx=0;
    setInterval(function(){idx=(idx+1)%MSGS.length;el.style.opacity='0';setTimeout(function(){el.textContent=MSGS[idx];el.style.opacity='1';},300);},4000);
  }
  if(document.readyState!=='loading')initAnn();else document.addEventListener('DOMContentLoaded',initAnn);
  setTimeout(initAnn,800);setTimeout(initAnn,2000);
})();

(function(){
  function initStock(){
    var t=document.querySelector('.flex-div-2 .icon-and-text');
    if(!t||t.dataset.bfStockDone)return;
    t.dataset.bfStockDone='1';
    t.textContent='Maz krājumā - atlikuši 7';
  }
  if(document.readyState!=='loading')initStock();else document.addEventListener('DOMContentLoaded',initStock);
  setTimeout(initStock,800);setTimeout(initStock,2000);
})();

/* ===== Barefoot BOGO "combinations" box (voya-style, no app) ===== */
(function(){
  function money(c){return '€'+(c/100).toFixed(2).replace('.',',');}
  function esc(s){return String(s).replace(/"/g,'&quot;');}
  function build(product){
    if(document.querySelector('[data-bf-combo]'))return;
    var anchor=document.querySelector('.flex-div-2')||document.querySelector('.product__selectors');
    var parent=anchor?anchor.parentNode:document.querySelector('.product__form');
    if(!parent)return;
    var colors=[],sizes=[];
    product.variants.forEach(function(v){if(colors.indexOf(v.option1)<0)colors.push(v.option1);if(v.option2&&sizes.indexOf(v.option2)<0)sizes.push(v.option2);});
    function vid(c,s){var f=product.variants.filter(function(v){return v.option1===c&&v.option2===s;})[0];return f?f.id:null;}
    function options(arr,sel){return arr.map(function(x){return '<option value="'+esc(x)+'"'+(x===sel?' selected':'')+'>'+x+'</option>';}).join('');}
    var firstAvail=product.variants.filter(function(v){return v.available;})[0]||product.variants[0];
    var dc=firstAvail.option1, ds=firstAvail.option2;
    var price=product.price, comp=price*2;
    var h=''
     +'<div class="bf-combo" data-bf-combo>'
     +'<div class="bf-combo__head"><span>IESPĒJAMĀS KOMBINĀCIJAS</span></div>'
     +'<div class="bf-combo__card">'
     +'<span class="bf-combo__badge">1+1 DERĪGS LĪDZ 23:59</span>'
     +'<div class="bf-combo__top"><span class="bf-combo__radio"></span>'
     +'<div class="bf-combo__titles"><strong>Pērc 1, saņem 1 bezmaksas</strong><span>2 pāri</span></div>'
     +'<div class="bf-combo__price"><b>'+money(price)+'</b><s>'+money(comp)+'</s></div></div>'
     +'<div class="bf-combo__pairs">'
     +'<div class="bf-combo__pair"><span class="bf-combo__num">#1</span>'
       +'<select class="bf-combo__sel" data-pair="1" data-type="color">'+options(colors,dc)+'</select>'
       +'<select class="bf-combo__sel" data-pair="1" data-type="size">'+options(sizes,ds)+'</select></div>'
     +'<div class="bf-combo__pair"><span class="bf-combo__num">#2</span>'
       +'<select class="bf-combo__sel" data-pair="2" data-type="color">'+options(colors,dc)+'</select>'
       +'<select class="bf-combo__sel" data-pair="2" data-type="size">'+options(sizes,ds)+'</select></div>'
     +'</div></div>'
     +'<button type="button" class="bf-combo__atc" data-bf-atc>Pievienot grozam</button>'
     +'</div>';
    var box=document.createElement('div');box.innerHTML=h;box=box.firstChild;
    if(anchor){parent.insertBefore(box,anchor.nextSibling);}else{parent.appendChild(box);}
    document.documentElement.classList.add('bf-combo-active');
    function selVal(p,t){var e=box.querySelector('select[data-pair="'+p+'"][data-type="'+t+'"]');return e?e.value:null;}
    box.querySelector('[data-bf-atc]').addEventListener('click',function(){
      var b=this;
      var id1=vid(selVal('1','color'),selVal('1','size'));
      var id2=vid(selVal('2','color'),selVal('2','size'));
      if(!id1||!id2){alert('Šī kombinācija nav pieejama, lūdzu izvēlieties citu.');return;}
      b.disabled=true;var old=b.textContent;b.textContent='...';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id1,quantity:1},{id:id2,quantity:1}]})})
        .then(function(r){return r.json();}).then(function(){window.location.href='/cart';})
        .catch(function(){b.disabled=false;b.textContent=old;});
    });
  }
  function init(){
    fetch(location.pathname.split('?')[0]+'.js').then(function(r){return r.json();}).then(build).catch(function(){});
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
